import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'

const canBeDrilledDown = (applicationSettings: any) => (widgetSetting: DashboardWidgetType) =>
  widgetSetting.includedProductHierarchy === undefined ||
  widgetSetting.includedProductHierarchy === null ||
  widgetSetting.includedProductHierarchy.length <
    applicationSettings.analysisProductHierarchyFilterCount

const isOverMaxInput = (applicationSettings: any) => (insights: InsightData[]) =>
  insights.length > applicationSettings.analysisMaxUserTags

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => ({
  ...widgetSetting,
  includedProductHierarchy: [
    ...(widgetSetting.includedProductHierarchy || []),
    Array.from(insights).map((insight) => insight.name)
  ]
})

const generateIncludedProductHierarchyStrategy = (
  applicationSettings: any
): WidgetSettingComposingStrategy => ({
  canBeDrilledDown: canBeDrilledDown(applicationSettings),
  isOverMaxInput: isOverMaxInput(applicationSettings),
  composeDrillDownWidgetSetting
})

export default generateIncludedProductHierarchyStrategy
